import { defineStore } from "pinia";

export const useNavigationStore = defineStore({
  id: "navigation",
  state: () => ({ open: false, id: 0, data: {} }),
  getters: {
    getData(state) {
      return state.data;
    },
  },
});
